import JSXComponent from "../../../../dist/jsx-render/JSXComponent";
import dom from "../../../../dist/jsx-render/dom";
import { WidgetMeasureText } from "../Widgets/WidgetMeasureText";
import { MeasureTextProvider } from "./Util/MeasureTextProvider";
import { LanguageString } from "../../../Model/LanguageString";
import { app } from "../../../Frame/App";

export type WidgetMeasureTextComponentProps = {
    widget: WidgetMeasureText;
    measureId: number;
}

export class WidgetMeasureTextComponent extends JSXComponent {
    props: WidgetMeasureTextComponentProps;
    title: string;
    content: string;

    constructor(props: WidgetMeasureTextComponentProps) {
        super(props);

        this.title = (this.props.widget.props.title["value" + app.languageUpperCase] && this.props.widget.props.title["value" + app.languageUpperCase].trim().length > 0) ? this.props.widget.props.title["value" + app.languageUpperCase] : this.props.widget.props.title["value" + app.defaultLanguageUpperCase];
        this.content = this.props.widget.props.content;
    }

    public element: HTMLElement;
    getElement = () => {
        this.element = <div className="widget Background-Blur-90-MSO">
            {this.props.widget.props.title ?
                <div className="title-row">
                    <div className="title mr-auto">{this.title}</div>
                </div>
                : []}
            {this.content ?
                <div className="content-row">
                    {this.props.widget.parseContentToHtml(this.content)}
                </div>
                : []}
        </div>;
    }

    public render(): HTMLElement {
        this.replaceText();
        this.getElement();

        this.props.widget.setGridPosition();
        return this.element;
    }

    public replaceText = () => {
        this.title = MeasureTextProvider.replaceMeasureText(this.title, this.props.measureId);
        this.content = MeasureTextProvider.replaceMeasureText(this.content, this.props.measureId);
    }
}